import type { Deal } from "@/lib/types/database/deals";
import { formatCurrency } from "@west-tennessee-consulting/ui/lib/currency";

export const dealTitleTemplate = (deal: Deal) => deal.title;

export const dealDescriptionTemplate = (deal: Deal) => {
  // `stage`, `currency` and `close_probability` are all NULLABLE columns — the
  // hand-written `Deal` used to claim otherwise, so this read `deal.stage`
  // unguarded and would have thrown on a stage-less deal (#2633).
  const stageLabel = deal.stage
    ? deal.stage.charAt(0).toUpperCase() + deal.stage.slice(1)
    : "No stage";
  const amountFormatted = formatCurrency(deal.revenue, {
    currency: deal.currency ?? undefined,
    fallback: "",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  const probability = deal.close_probability ?? 0;

  return `${stageLabel} • ${amountFormatted} • ${probability}% probability`;
};
